module.exports = __webpack_public_path__ + "img/21_87.7954030d.png";